


























































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { BIcon, BIconUpload } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    BIcon,
    BIconUpload,
    NextPrevBtn,
    Footer,
  },
})
export default class ReadIslander extends Vue {
  protected nxtprevReadIslander =
  {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail2.png",
    NextImage: "/thumbnail7.png",
    PrevLink: "/PlaisirdeLire/LesEssaisEtTemoignages",
    NextLink: "/PlaisirdeLire/BandesDessinees",
  };
}
